
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ISummary } from '@/api/types/stats';

import { ITableHeader } from "@/utils";

@Component({
    components: {
    },
})
export default class ExtendedReportTableFooter extends Vue {
    @Prop({ required: true, default: [] }) numberFormatting!: { slot: string, key: string }[];
    @Prop({ required: true }) headers!: ITableHeader[];
    @Prop({ required: true }) item!: ISummary;
}
